import { useCommunityContext } from 'providers';
import { useMemo } from 'react';

import { useUserCommunityMembershipQuery } from 'shared/graphql';

/**
 * Fetch and return the user's membership in the selected community.
 * The hook combines user and community context, and queries for the user's membership in the selected community.
 * @see https://github.com/jebelapp/jebel/issues/1841
 */
export function useUserCommunityMembership(user: string) {
  const { selectedCommunity: school, loading: schoolLoading } = useCommunityContext();

  const { data, loading } = useUserCommunityMembershipQuery({
    skip: !user || !school,
    variables: {
      user,
      community: school?.id as string,
    },
  });

  const membership = useMemo(() => {
    // Memoize the membership data for performance
    return data?.memberships?.items?.[0] ?? null;
  }, [data, user, school]);

  return {
    data: membership,
    loading: schoolLoading || loading,
  };
}
